/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Badge from 'shared/ui/components/Badge.vue';
import ExpandDetails from 'shared/ui/components/ExpandDetails.vue';

/**
 * @typedef {object} Capture
 * @prop {string} name
 * @prop {number} timestamp
 * @prop {string} sponsor
 *
 * @typedef {object} Appointment
 * @prop {string} name
 * @prop {number} start_timestamp
 * @prop {number} duration
 * @prop {string} status
 */

const __vue_script__ = {
    name: 'ProspectDetails',

    components: {
        Badge,
        ExpandDetails,
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        edit: {
            type: Boolean,
            default: false
        },

        model: {
            type: Object,
            required: true
        },

        options: {
            type: Object,
            default: () => null
        }
    },

    data() {
        return {
            /** @type {Capture[]} */
            captures: [],
            /** @type {Appointment[]} */
            appointments: [],
        };
    },

    created() {
        this.getDetailsData();
    },

    methods: {
        async getDetailsData() {
            try {
                const res = await this.$services.appScripts.callAppScript(
                    this.event._id,
                    'prospects/bstg-details',
                    { prospectId: this.model._id },
                );
                this.captures = res.captures
                    .toSorted((a, b) => a.timestamp > b.timestamp ? 1 : -1);
                this.appointments = res.appointments
                    .toSorted((a, b) => a.start_timestamp > b.start_timestamp ? 1 : -1);
            } catch (err) {
                console.error('[ProspectDetails] could not get details', err);
            }
        },

        /** @type {(timestamp: number) => string} */
        getCaptureDate(timestamp) {
            const date = this.$utils.time.tsToFormat(
                timestamp, 'LLL', this.event.timezone,
            );
            return `${this.$t('prospect.acquisition_time')}: ${date}`;
        },

        /** @type {(start_timestamp: number, duration: number) => string} */
        getAppointmentDate(start_timestamp, duration) {
            const start = this.$utils.time.tsToFormat(
                start_timestamp, 'LLL', this.event.timezone,
            );
            const end = this.$utils.time.tsToFormat(
                start_timestamp + duration, 'LT', this.event.timezone,
            );
            return `${start} - ${end}`;
        },

        /** @type {(status: string) => string} */
        getAppointmentStatus(status) {
            return `${this.$t('prospect.attendance_status')}: ${status}`;
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.edit
    ? _c(
        "div",
        { staticClass: "prospect-details" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("prospect.details")))]),
          _c(
            "expand-details",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "summary",
                    fn: function (ref) {
                      return [
                        _c(
                          "h5",
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("prospect.captures_title"))),
                            ]),
                            _c("badge", { staticClass: "info" }, [
                              _vm._v(_vm._s(_vm.captures.length)),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                3504397735
              ),
            },
            _vm._l(_vm.captures, function (d) {
              return _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "icon-column" }, [
                  _c("i", { staticClass: "ic-in-person" }),
                ]),
                _c("div", [
                  _c("p", [_vm._v(_vm._s(d.name))]),
                  _c("div", { staticClass: "control-hint" }, [
                    _vm._v(_vm._s(_vm.getCaptureDate(d.timestamp))),
                  ]),
                  _c("div", { staticClass: "control-hint" }, [
                    _vm._v(_vm._s(d.sponsor)),
                  ]),
                ]),
              ])
            }),
            0
          ),
          _c(
            "expand-details",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "summary",
                    fn: function (ref) {
                      return [
                        _c(
                          "h5",
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("prospect.appointments_title"))
                              ),
                            ]),
                            _c("badge", { staticClass: "info" }, [
                              _vm._v(_vm._s(_vm.appointments.length)),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                3088608679
              ),
            },
            _vm._l(_vm.appointments, function (d) {
              return _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "icon-column" }, [
                  _c("i", { staticClass: "ic-calendar-agenda" }),
                ]),
                _c("div", [
                  _c("p", [_vm._v(_vm._s(d.name))]),
                  _c("div", { staticClass: "control-hint" }, [
                    _vm._v(
                      _vm._s(
                        _vm.getAppointmentDate(d.start_timestamp, d.duration)
                      )
                    ),
                  ]),
                  _c("p", [_vm._v(_vm._s(_vm.getAppointmentStatus(d.status)))]),
                ]),
              ])
            }),
            0
          ),
        ],
        1
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/prospects/ProspectDetails.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__